import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=2d8291f6&scoped=true&"
import script from "./CommonForm.vue?vue&type=script&lang=js&"
export * from "./CommonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8291f6",
  null
  
)

export default component.exports